import { centralDate, calendarDate } from './registrationCalendar';
// Inclusive calendar bounds use Texas Central time, independent of browser timezone.
export const tenantDate = centralDate;

export function registrationRange(preset, now = new Date()) {
  if (preset === 'all' || preset === 'custom') return { start: '', end: '' };
  const end = tenantDate(now);
  const start = new Date(`${end}T00:00:00Z`);
  if (preset === 'year') {
    start.setUTCMonth(0, 1);
  } else if (preset === '2years') {
    start.setUTCFullYear(start.getUTCFullYear() - 2);
  } else {
    start.setUTCDate(start.getUTCDate() - Number(preset) + 1);
  }
  return { start: calendarDate(start), end };
}

export function filterRegistrations(tenants, start, end) {
  if (start && end && start > end) return [];
  if (!start && !end) return tenants;
  return tenants.filter(tenant => {
    const date = tenantDate(tenant.created_at);
    return date && (!start || date >= start) && (!end || date <= end);
  });
}

export function tenantLicenseLabel(tenant) {
  if (tenant.license_type !== 'pro') return 'Community';
  return ({ trial: 'Pro (trial)', paid: 'Pro (paid)', manual: 'Pro (manual)' })[tenant.license_source] || 'Pro (source unknown)';
}
